import { deleteCookie, getCookie, setCookie } from "cookies-next/client";

export const SESSION_COOKIE_NAME = "jwt";

const SEVEN_DAYS_IN_SECONDS = 7 * 24 * 60 * 60;

const sharedCookieScope = {
  path: "/",
  ...(process.env.NEXT_PUBLIC_DOMAIN && {
    domain: process.env.NEXT_PUBLIC_DOMAIN,
  }),
};

const hostOnlyCookieScope = { path: "/" };

export const sessionCookieOptions = {
  ...sharedCookieScope,
  sameSite: "lax" as const,
  secure: process.env.NODE_ENV === "production",
  maxAge: SEVEN_DAYS_IN_SECONDS,
};

export const readSessionToken = (): string | undefined => {
  const token = getCookie(SESSION_COOKIE_NAME);

  return typeof token === "string" && token !== "" ? token : undefined;
};

// A host-only "jwt" cookie may linger from a previous version that wrote the
// refreshed token without a domain; removing it keeps a single cookie so the
// browser never serves a stale duplicate ahead of the shared one.
const removeHostOnlyDuplicate = (): void => {
  if (!sharedCookieScope.domain) return;

  deleteCookie(SESSION_COOKIE_NAME, hostOnlyCookieScope);
};

export const writeSessionToken = (token: string): void => {
  removeHostOnlyDuplicate();
  setCookie(SESSION_COOKIE_NAME, token, sessionCookieOptions);
};

export const clearSessionToken = (): void => {
  removeHostOnlyDuplicate();
  deleteCookie(SESSION_COOKIE_NAME, sharedCookieScope);
};
